import React from 'react';
import {
  FuelTypography,
  FuelGridContainer,
  FuelGridItem,
} from '@frete.com/fuel-react';
import ReloadButton from '@components/application/JourneyManagement/ButtonReload';
import Filters from '../../Filters';

function HeaderMobile() {
  return (
    <>
      <FuelGridContainer
        gapRow={24}
        style={{ margin: 0, paddingTop: 40 }}
        data-testid="header-mobile"
      >
        <FuelGridItem sm={2} md={4}>
          <FuelTypography size="heading-md" weight="bold">
            Viagem e monitoramento
          </FuelTypography>
        </FuelGridItem>
        <FuelGridItem
          sm={2}
          md={4}
          style={{ alignContent: 'end', justifySelf: 'end' }}
        >
          <ReloadButton />
        </FuelGridItem>
        <FuelGridItem sm={4} md={8} />
      </FuelGridContainer>
      <Filters isMobile />
    </>
  );
}

export default HeaderMobile;
